import React, { ReactElement } from "react";

interface Props {
  children: ReactElement;
  image?: string;
  className?: string;
}

const Centerpiece = ({ children, image = "", className = "" }: Props) => {
  return <div className="centerpiece">{children}</div>;
};

export default Centerpiece;
